import { VenueAnalysisSelection } from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';

export type HighlightedVenue = {
    venueTypeName: string;
    venueName?: string;
};

export type VenueAnalysisBarHighlightMode = 'VenueType' | 'Venue';

export function isVenueItemHighlighted(
    mode: VenueAnalysisBarHighlightMode,
    highlightedVenue?: HighlightedVenue,
    selection?: VenueAnalysisSelection,
    targetItem?: HighlightedVenue
): boolean {
    if (!highlightedVenue) {
        return false;
    }
    if (!targetItem) {
        return false;
    }
    if (mode === 'VenueType') {
        if (selection) {
            // When we have a selection, venue types are not highlighted if we are highlighting a venue...
            return (
                highlightedVenue.venueTypeName === targetItem.venueTypeName &&
                !highlightedVenue.venueName
            );
        }
        // Without a selection we only use the type i.e. in effect the whole venue type/venues block work as one...
        return targetItem.venueTypeName === highlightedVenue.venueTypeName;
    }

    if (mode === 'Venue') {
        if (selection) {
            return (
                highlightedVenue.venueTypeName === targetItem.venueTypeName &&
                highlightedVenue.venueName === targetItem.venueName
            );
        }
        return highlightedVenue.venueTypeName === targetItem.venueTypeName;
    }

    return false;
}
